<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("screen_seat_type_group", 1) }}
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="sstg_name"
                type="text"
                name="sstg_name"
                id="sstg_name"
                v-validate="'required'"
              />
              <label>Screen Seat Type Group</label>
            </div>
            <!-- <Tooltip :title="$t('movie_label_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && !sstg_name">{{ "Required." }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="sstg_is_active"
              name="check-button"
              switch
              class="j-checkbox"
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button @click.prevent.stop="resetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="screen-seat-type-group"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
export default {
  components: {},
  data() {
    return {
      sstg_id: null,
      sstg_name: "",
      sstg_is_active: "Y",
      btenable: false,
      submitted: false,
    };
  },
  beforeMount() {},
  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.getScreenSeatTypeGroupDetails(id);
    }
  },
  methods: {
    getScreenSeatTypeGroupDetails(sstg_id) {
      let payload = {
        sstg_id: sstg_id,
      };
      MasterService.GetScreenSeatTypeGroup(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.sstg_name = data.Records[0].sstg_name;
              this.sstg_id = data.Records[0].sstg_id;
              this.sstg_is_active = data.Records[0].sstg_is_active;
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          } else {
            console.log("Error:", data.message);
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.sstg_name) {
            return this.$toasted.show("Please Enter Group Name");
          } else {
            let payload = {
              sstg_id: this.sstg_id,
              sstg_name: this.sstg_name,
              sstg_is_active: this.sstg_is_active,
            };
            if (this.sstg_id) {
              MasterService.EditScreenSeatTypeGroup(payload)
                .then((response) => {
                  this.btenable = false;
                  const { data } = response;
                  if (data && data.status) {
                    this.resetForm();
                    if (redirect) {
                      this.$router.push({
                        path: "/master/screen-seat-type-group",
                      });
                    }
                    this.submitted = false;
                    this.$toasted.show(data.message);
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch((err) => {
                  console.log("Error:", err);
                });
            } else {
              MasterService.AddScreenSeatTypeGroup(payload)
                .then((response) => {
                  this.btenable = false;
                  const { data } = response;
                  if (data && data.status) {
                    this.resetForm();
                    if (redirect) {
                      this.$router.push({
                        path: "/master/screen-seat-type-group",
                      });
                    }
                    this.submitted = false;
                    this.$toasted.show(data.message);
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch((err) => {
                  console.log("Error:", err);
                });
            }
          }
        }
      });
    },
    resetForm: function () {
      this.sstg_id = null;
      this.sstg_name = "";
      this.sstg_is_active = "Y";
      this.submitted = false;
      this.btenable = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ScreenSeatTypeGroup/AddScreenSeatTypeGroup.vue